{
  "add_extra_cabin": "Add extra cabin",
  "apply": "Apply",
  "availability": "Availability",
  "available_for_single_use": "This cabin is bookable for single use.",
  "button_title": {
    "add_person": "Add a person to the cabin",
    "close_departure": "Collapse departure block",
    "open_departure": "Expand departure block",
    "remove_person": "Remove a person from the cabin"
  },
  "cabin_x": "Cabin {{ count }}",
  "clear": "Clear",
  "clear_filter": "Clear filters",
  "close": "Close",
  "date": "Date",
  "departure": "Departure",
  "departure_statuses": {
    "available": "Available",
    "fully_booked": "Fully booked",
    "on_request": "On request",
    "only_x_left": "Only {{ count }} left"
  },
  "discount_amount": "–{{value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0)}}",
  "discount_percentage": "–{{value}}%",
  "filter_results": "Filter results",
  "filter_tours": "Filter tours",
  "format": {
    "date": "{{value, datetime(day: numeric; month: short; year: numeric)}}",
    "month": "{{value, datetime(month: long; year: numeric)}}",
    "price": "{{value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0)}}",
    "price_per_person": "{{value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0)}} p.p.",
    "weekday": "{{value, datetime(weekday: long)}}"
  },
  "fully_booked": {
    "after_one": "<0>{{count}} fully booked date</0><1> found after </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "after_other": "<0>{{count}} fully booked dates</0><1> found after </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "before_one": "<0>{{count}} fully booked date</0><1> found before </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "before_other": "<0>{{count}} fully booked dates</0><1> found before </1><2>{{date, datetime(day: numeric; month: short; year: numeric)}}</2>",
    "between_one": "<0>{{count}} fully booked date</0><1> found between </1><2>{{afterDate, datetime(day: numeric; month: short; year: numeric)}}</2><3> & </3><4>{{beforeDate, datetime(day: numeric; month: short; year: numeric)}}</4>",
    "between_other": "<0>{{count}} fully booked dates</0><1> found between </1><2>{{afterDate, datetime(day: numeric; month: short; year: numeric)}}</2><3> & </3><4>{{beforeDate, datetime(day: numeric; month: short; year: numeric)}}</4>",
    "only_one": "<0>{{count}} fully booked date</0><1> found</1>",
    "only_other": "<0>{{count}} fully booked dates</0><1> found</1>"
  },
  "guaranteed": "Guaranteed",
  "guidance": "Guidance",
  "guidance_types": {
    "Guided": "Guided",
    "Independent": "Independent",
    "Semi-Guided": "Semi-Guided"
  },
  "load_more": "Load more",
  "load_more_dates": "Load more dates",
  "maximum_occupancy_x_one": "Max {{ count }} person",
  "maximum_occupancy_x_other": "Max {{ count }} persons",
  "only_x_left": "Only {{ count }} left",
  "persons": "Persons",
  "persons_in_cabins": "{{ persons }} in {{ cabins }}",
  "port_of_departure": "Port of departure",
  "prices_from": "Prices from",
  "remove_cabin": "Remove cabin",
  "remove_x_cabins_one": "Remove cabin",
  "remove_x_cabins_other": "Remove {{count}} cabins",
  "select_available_cabins": "Select available cabins",
  "select_this_cabin": "Select this cabin",
  "sgr": "{{count}}x {{ value, currency(currency: EUR; minimumFractionDigits: 0; maximumFractionDigits: 0) }} SGR - Insolvency protection",
  "ship": "Ship",
  "show_x_tours_one": "Show {{ count }} tour",
  "show_x_tours_other": "Show {{ count }} tours",
  "single_use_notice": "Single occupancy supplement applies when the cabin is used by one person.",
  "sort_by": "Sort by",
  "sort_keys": {
    "price": "Price",
    "start_date": "Start date"
  },
  "start_booking": "Start booking",
  "start_date": "Start date",
  "tooltips": {
    "guaranteed": {
      "description": "This departure is guaranteed to depart, even if the minimum number of passengers has not been reached.",
      "title": "What is guaranteed?"
    },
    "on_request": {
      "description": "\"Available on request\" means we need to double-check availability for several reasons; we'll confirm your booking or propose alternatives within 48 hours.",
      "title": "What does on request mean?"
    }
  },
  "total_price": "Total price",
  "view_cabin": "View details",
  "view_ship": "View ship",
  "year": "Year",
  "x_cabins_one": "{{ count }} cabin",
  "x_cabins_other": "{{ count }} cabins",
  "x_left": "{{ count }} left",
  "x_person_cabin": "{{ count }} person cabin",
  "x_persons_one": "{{ count }} person",
  "x_persons_other": "{{ count }} persons",
  "x_to_y_person_cabin": "{{ min }}-{{ max}} person cabin",
  "x_tours_one": "{{ count }} tour",
  "x_tours_other": "{{ count }} tours"
}
